export default {
  meta: {
    title: '供应商管理'
  }
};
